import type { BetterAuthClientPlugin } from 'better-auth/client'
import type { legacyAuthPlugin } from './legacy/server-plugin'
export const legacyAuthClientPlugin = () =>
  ({
    id: 'argus-auth-legacy',
    $InferServerPlugin: {} as ReturnType<typeof legacyAuthPlugin>,
  }) satisfies BetterAuthClientPlugin
